import { Record } from 'immutable';

const MentorRecord = Record({
  groupId: undefined,
  studentId: undefined,
  unitId: undefined,
  wordsMastered: undefined,
  wordsStudying: undefined,
  wordsAssigned: undefined,
});

class Mentor extends MentorRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'studentId':
    case 'unitId':
      return [key, `${val}`]; // stringify
    default:
      return [key, val];
  }
};

Mentor.create = (data) => new Mentor(data).mapEntries(reviver);

export default Mentor;



// WEBPACK FOOTER //
// ./data/Mentor/model/model.js